module.exports = __webpack_public_path__ + "static/img/2.7ca1cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/2.png
// module id = fnx0
// module chunks = 35